<!--
Author: TangChen
Date: 2018-12-26
Desc: 定投基金详情，由index.js 配置引入
-->
<template>
    <div>
        <comp-title-dc back-url-name="myplan" :back-url-query="{ planType: planType }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/myplan' }">我的定投</el-breadcrumb-item>
                <el-breadcrumb-item
                    :to="{
                        path: '/myplan?planType=' + planType
                    }"
                >
                    {{ planTypeArr[planType] }}
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-plan-detail bizcomp">
            <div class="plan-desc-contain">
                <div class="plan-desc-content">
                    <div class="plan-desc-head">
                        <div class="my-plan-achieve">
                            <img
                                class="plan-achieve-img"
                                src="../../assets/img/my-plan-log.png"
                                alt=""
                            />
                            <span class="plan-achieve-text">我的定投成就</span>
                        </div>
                        <div class="plan-status">
                            <span class="plan-status-title">定投状态：</span>
                            <span class="plan-status-value">
                                {{ formatterStatus(fund.status) }}
                            </span>
                        </div>
                    </div>
                    <div class="plan-total-info">
                        <div class="total-info-time">
                            <div class="color-fd6112-bold">
                                {{ headData.planTime }}
                            </div>
                            <div class="color-f79472">定投设置时长</div>
                        </div>
                        <div class="total-info-num">
                            <div class="color-fd6112-bold">{{ headData.planNum }}期</div>
                            <div class="color-f79472">扣款成功期数</div>
                        </div>
                        <div class="total-info-money">
                            <div class="color-fd6112-bold">
                                {{ $util.fmtNum(headData.planMoney) }}元
                            </div>
                            <div class="color-f79472">成功扣款总额</div>
                        </div>
                    </div>
                </div>
                <div
                    class="fund-desc-infos"
                    :style="{ padding: isNotCombo ? '19px 16px' : '0 0 16px 0' }"
                >
                    <div
                        class="fund-desc-info1"
                        :style="{
                            background: isNotCombo ? 'none' : '#f9f9f9',
                            padding: isNotCombo ? '0' : '10px 16px'
                        }"
                    >
                        <div class="buy-plan-name">
                            {{ fund.buyplanname }}
                        </div>
                        <!-- 普通定投展示 -->
                        <div v-if="isNotCombo" class="fund-desc">
                            <div class="fund-desc-name">
                                {{ fund.fundname }}
                            </div>
                            <div class="fund-desc-code">
                                {{ fund.fundcode }}
                            </div>
                            <div class="fund-desc-sharetype">
                                {{
                                    fund.sharetype == "0"
                                        ? "前收费"
                                        : fund.sharetype == "1"
                                        ? "后收费"
                                        : ""
                                }}
                            </div>
                        </div>
                        <!-- 组合定投展示 -->
                        <div v-else class="fund-desc2">
                            <div class="fund-desc-combin-name">{{ fund.portfolioname }}</div>
                            <div class="fund-desc-codewrap">
                                <div
                                    v-for="item in fund.portfolioinfo"
                                    :key="item.fundcode"
                                    class="fund-desc-code-item"
                                >
                                    <div class="fund-desc-name">
                                        {{ item.fundname }}
                                    </div>
                                    <div class="fund-desc-code">
                                        {{ item.fundcode }}
                                    </div>
                                    <div class="fund-desc-sharetype">
                                        {{
                                            item.sharetype === "0"
                                                ? "前收费"
                                                : item.sharetype === "1"
                                                ? "后收费"
                                                : ""
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="isNotCombo"
                            class="fund-page-btn"
                            v-on:click.stop="gotoDetail(fund.fundcode)"
                        >
                            基金详情
                            <i class="el-icon-arrow-right" ria-hidden="true"></i>
                        </div>
                    </div>
                    <div
                        class="fund-desc-info2 font-14"
                        :style="{ padding: isNotCombo ? '0' : '0 16px' }"
                    >
                        <div class="width-146">
                            <div class="color-666">
                                {{ planType == "4" ? "基础金额" : "扣款金额" }}
                            </div>
                            <div class="color-333">
                                {{ formatterNum(fund.firstinvestamount) }}
                            </div>
                        </div>
                        <div class="width-180">
                            <div class="color-666">扣款账户</div>
                            <div class="color-333">
                                <span v-if="fund.channelid && fund.bankcode && fund.depositcard">
                                    {{
                                        $cache.getDict("110079", fund.channelid.substr(0, 4)) +
                                        "-" +
                                        $cache.getDict("110080", fund.bankcode).substr(-4, 4) +
                                        "（" +
                                        fund.depositcard.substr(-4, 4) +
                                        "）"
                                    }}
                                </span>
                                <span v-else>--</span>
                            </div>
                        </div>
                        <div class="width-146">
                            <div class="color-666">扣款时间</div>
                            <div class="color-333">
                                {{ formatterCycle(fund) }}
                            </div>
                        </div>
                        <div class="width-156">
                            <div class="color-666">预计下次扣款时间</div>
                            <div class="color-333">
                                {{ $util.fmtDate(fund.nextinvestdate) }}
                            </div>
                        </div>
                        <div class="width-146">
                            <div class="color-666">扣款方式</div>
                            <div class="color-333">
                                {{ formatterPlanMode(fund.saveplanmode) }}
                            </div>
                        </div>
                    </div>
                    <div class="fund-desc-btns">
                        <div
                            v-if="
                                fund.statusText.indexOf('c') > -1 &&
                                fund.statusText.indexOf('s') === -1 &&
                                isNotCombo
                            "
                            class="fund-desc-btn"
                            v-on:click.prevent="btnAction('c')"
                        >
                            修改
                        </div>
                        <div
                            v-if="fund.statusText.indexOf('s') > -1 && isNotCombo"
                            class="fund-desc-btn"
                            v-on:click.prevent="btnAction('s')"
                        >
                            恢复
                        </div>

                        <div
                            v-if="fund.statusText.indexOf('p') > -1 && isNotCombo"
                            class="fund-desc-btn magin-left"
                            v-on:click.prevent="btnAction('p')"
                        >
                            暂停
                        </div>
                        <div
                            v-if="fund.statusText.indexOf('e') > -1"
                            class="fund-desc-btn magin-left"
                            v-on:click.prevent="btnAction('e')"
                        >
                            终止
                        </div>
                        <el-tooltip
                            v-else
                            class="item"
                            effect="info"
                            :content="'定投状态为' + formatterStatus(fund.status) + ',不允许操作'"
                            placement="right"
                        >
                            <div class="fund-desc-btn">终止</div>
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <plan-deduction-dc></plan-deduction-dc>
        </div>
        <msg-dialog
            v-if="dialog"
            :dialog="dialog"
            :private-info="wisdomInfo"
            v-on:event-fn="btnDialog"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import msgDialog from "@/components/misc/msgDialog";
import format from "date-fns/format";
import fundApi from "@/api/fund";
import planDeductionDc from "@/bizcomponents/general/planDeductionDc.vue";
export default {
    name: "PlanDetail",
    components: {
        msgDialog,
        planDeductionDc
    },
    mixins: [mixin],
    data() {
        return {
            fund: {},
            wisdomInfo: {},
            dialog: false,
            cancelOrderId: "",
            planType: "1",
            planTypeArr: {
                1: "普通定投",
                7: "目标盈定投",
                4: "智能定投",
                a: "组合定投"
            },
            headData: {
                planTime: "",
                planNum: "",
                planMoney: ""
            }
        };
    },
    computed: {
        // true时表示非组合定投，false时表示组合定投
        isNotCombo() {
            return this.fund.planflag !== "a";
        }
    },
    created() {
        // 获取基金信息
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        const dateTime = new Date(this.$util.fmtDate(this.fund.operdate));
        const dateTimeToday = new Date();
        const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
        const differenceInDays = Math.round(Math.abs((dateTimeToday - dateTime) / oneDay));
        this.headData.planTime = this.getYearsMonthsDays(differenceInDays);
        this.headData.planNum = this.fund.totalsucctimes;
        this.headData.planMoney = this.fund.totalsuccamount;
        this.planType = this.$route.query.planType;
        this.getNewFund();
    },
    methods: {
        gotoDetail(val) {
            this.$util.toFundDetailPage(val);
        },
        getYearsMonthsDays(totalDays) {
            let years = 0;
            let months = 0;
            let remainingDays = totalDays;
            while (remainingDays >= 365) {
                // 当剩余天数大于或等于一年的天数时
                remainingDays -= 365; // 减去一年的天数
                years++; // 年份增加
            }
            while (remainingDays >= 30) {
                // 当剩余天数大于或等于一个月的天数时
                remainingDays -= 30; // 减去一个月的天数
                months++; // 月份增加
            }
            if (years > 0) {
                return years + "年" + months + "个月";
            } else {
                if (months > 0) {
                    return months + "个月" + remainingDays + "日";
                } else {
                    return remainingDays + "日";
                }
            }
        },
        formatterStatus(value) {
            if (value == "N") {
                return "正常";
            } else if (value == "P") {
                return "暂停";
            } else {
                return "终止";
            }
        },
        formatterNum(value) {
            if (value.indexOf(",") > -1) {
                const _x = value.split(",");
                let _z = "";
                // 定转显示
                for (let i in _x) {
                    _z += this.$util.fmtNum(_x[i]) + "</br>";
                }
                return _z;
            }
            return this.$util.fmtNum(value);
        },
        formatterCycle(row) {
            if (!row.investcycle || !row.investcyclevalue) {
                return "";
            }
            const cyclestr =
                (row.investcycle == "2" ? "每" : "") +
                this.$cache.getDict("110009", row.investcycle); // 0-每月，1-每周，2-双周，3-每日
            let valuestr;
            if (row.investcycle == "0") {
                valuestr = row.investcyclevalue + "日";
            } else if (row.investcycle == "3") {
                valuestr = "";
            } else {
                valuestr = "星期" + this.$util.numsDayToText(row.investcyclevalue);
            }
            return cyclestr + (this.$util.isEmpty(valuestr) ? "" : valuestr);
        },
        formatterPlanMode(saveplanmode) {
            return saveplanmode == "2"
                ? this.$const.getXJBParam("sname") + "定投"
                : saveplanmode == "3"
                ? "省钱购定投"
                : "银行卡定投";
        },
        // 获取基金可用操作
        getNewFund() {
            const acctStatus = this.$cache.getUser().status;
            const status = this.fund.status;
            let btnArr = "";
            // 组合定投
            if (!this.isNotCombo) {
                if (status === "N") {
                    btnArr = "e";
                } else if (status === "P") {
                    if (acctStatus === "7") {
                        btnArr = "e";
                    } else {
                        btnArr = "s,e";
                    }
                }
            } else {
                // 普通定投
                if (status === "N") {
                    if (acctStatus === "7") {
                        btnArr = "p,e";
                    } else {
                        btnArr = "c,p,e";
                    }
                } else if (status === "P") {
                    if (acctStatus === "7") {
                        btnArr = "e";
                    } else {
                        btnArr = "c,s,e";
                    }
                }
            }
            this.fund.statusText = btnArr;
        },
        // 按钮响应处理
        btnAction(cate) {
            if (cate === "c" || cate === "s") {
                this.fund.proto = "plan";
                this.$util.fundRiskCheck(this, this.fund, (res) => {
                    if (res) {
                        let _url = "";
                        let _way = "";
                        if (cate === "s") {
                            _url = "generalrecovery";
                            _way = "G2";
                        } else if (cate === "c") {
                            // 修改放下一版本
                            _url = "generalchange";
                            _way = "61";
                        }
                        const _x = Object.assign({}, res, { way: _way });
                        sessionStorage.setItem(_url, JSON.stringify(_x));
                        this.$router.push({
                            name: _url,
                            query: { fundcode: _x.fundcode }
                        });
                    }
                });
                return;
            }
            let _x = { method: "PUT" };
            if (cate === "p") {
                _x.cateText = "暂停";
                _x.url = "trade/plan/pause";
                _x.way = "G1";
                _x.action = "pause";
            } else if (cate === "e") {
                _x.cateText = "终止";
                _x.url = "trade/plan/recovery";
                _x.way = "60";
                _x.action = "close";
            } else if (cate === "cl") {
                _x.cateText = "撤销";
                _x.url = "trade/cancel";
                _x.method = "POST";
            }
            _x.cate = cate;

            _x.msg =
                "您确定执行" +
                `${this.isNotCombo ? this.fund.fundname : this.fund.portfolioname}` +
                "(" +
                `${this.isNotCombo ? this.fund.fundcode : this.fund.portfoliocode}` +
                ")基金" +
                _x.cateText +
                "定投协议操作？";
            _x.tit = _x.cateText + "定投协议提示";
            _x.tit = _x.cateText + "定投协议提示";
            _x.btn1 = "确认" + _x.cateText;
            _x.btn2 = "取消";
            this.wisdomInfo = _x;
            this.dialog = true;
        },
        // 按钮弹窗提示信息
        async btnDialog(val) {
            const _this = this;
            if (val) {
                let _x = {
                    planno: this.fund.planno,
                    transactionaccountid: this.fund.transactionaccountid,
                    action: val.action,
                    tradepassword: val.tpasswd
                };
                if (val.cate === "cl") {
                    _x = {
                        orderid: this.cancelOrderId,
                        tradepwd: val.tpasswd || ""
                    };
                }
                // 组合定投
                if (!this.isNotCombo) {
                    // 终止
                    if (val.cate === "e") {
                        _x.status = "3";
                        const res = await fundApi.combInvestPlanManager(_x);
                        if (res.data) {
                            _this.getFundInfo(_this.fund);
                        }
                    }
                } else {
                    const res = await fundApi.planOperation(_x);
                    if (val.cate === "cl") {
                        this.$router.push({ name: "myplan" });
                    }
                    if (res.data) {
                        _this.getFundInfo(_this.fund);
                    }
                }
            } else {
                this.dialog = false;
            }
        },
        // 获取定投协议信息
        async getFundInfo(data) {
            const res = await fundApi.getPlan({
                fundcode: data.fundcode
            });
            if (res.data && res.data.data) {
                const val = res.data.data.find((item) => {
                    return item.planno === data.planno;
                });
                if (!val) {
                    return;
                }
                if (val.comrate === "0.0000" || (val.mainplanno && val.mainplanno.trim() === "")) {
                    val.comrate = "";
                }
                this.fund = Object.assign({}, data, val);
                const _x = Object.assign({}, this.fund);
                sessionStorage.setItem("plandetail", JSON.stringify(_x));
                this.getNewFund();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-plan-detail {
    background: #ffffff;
    border: 1px solid var(--color-border-base);
    .plan-desc-contain {
        padding: 20px 21px 0;
    }
    .plan-desc-content {
        background: linear-gradient(0deg, var(--color-accent) 0%, var(--color-accent) 100%);
        border-radius: 6px;
        .plan-desc-head {
            display: flex;
            justify-content: space-between;
            .my-plan-achieve {
                width: 272px;
                height: 54px;
                display: flex;
                align-items: center;
                border-radius: 6px 0px 40px 0px;
                padding-left: 21px;
                background: linear-gradient(
                    180deg,
                    var(--color-accent) 0%,
                    var(--color-accent) 100%
                );
                .plan-achieve-text {
                    padding-left: 6.29px;
                    font-size: 26px;
                    font-weight: bold;
                    color: var(--color-primary);
                }
            }
            .plan-status {
                padding-right: 16px;
                height: 54px;
                line-height: 54px;
                .plan-status-title {
                    font-size: 16px;
                    color: var(--color-primary);
                }
                .plan-status-value {
                    font-size: 16px;
                    font-weight: 500px;
                    color: var(--color-primary);
                }
            }
        }
        .plan-total-info {
            display: flex;
            justify-content: center;
            height: 126px;
            align-items: center;
            .total-info-time {
                flex: 1;
                text-align: center;
            }
            .total-info-num {
                flex: 1;
                text-align: center;
                border-left: 1px solid var(--color-border-base);
                border-right: 1px solid var(--color-border-base);
            }
            .total-info-money {
                flex: 1;
                text-align: center;
            }
            font-size: 20px;
        }
    }
    .fund-desc-infos {
        padding: 19px 16px;
        background: #ffffff;
        margin-top: 20px;
        border: 1px solid var(--color-border-base);
        .fund-desc-info1 {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;
            .buy-plan-name {
                font-size: 18px;
                font-weight: bold;
                line-height: 20px;
                padding-bottom: 5px;
                flex: 0 0 100%;
            }
            .fund-desc {
                display: flex;
                height: 20px;
                line-height: 20px;
                .fund-desc-name {
                    font-size: 16px;
                    font-weight: bold;
                    color: var(--color-text-accent);
                }
                .fund-desc-code {
                    padding: 0 7px;
                    font-size: 14px;
                    color: var(--color-text-accent);
                    display: flex;
                    align-items: flex-end;
                }
                .fund-desc-sharetype {
                    font-size: 14px;
                    color: var(--color-text-accent);
                }
            }
            .fund-desc2 {
                display: flex;
                align-items: center;
                .fund-desc-combin-name {
                    font-size: 16px;
                    font-weight: bold;
                    color: var(--color-text-primary);
                }
                .fund-desc-codewrap {
                    margin-left: 14px;
                    padding-left: 14px;
                    border-left: 1px solid var(--color-border-base);
                }
                .fund-desc-code-item {
                    display: flex;
                }
                .fund-desc-name {
                    font-size: 14px;
                    color: var(--color-text-primary);
                }
                .fund-desc-code {
                    padding: 0 7px;
                    font-size: 14px;
                    color: var(--color-text-accent);
                    display: flex;
                    align-items: flex-end;
                }
                .fund-desc-sharetype {
                    font-size: 14px;
                    color: var(--color-text-accent);
                }
            }

            .fund-page-btn {
                cursor: pointer;
                font-size: 14px;
                color: var(--color-primary);
                display: flex;
                align-items: center;
            }
        }
        .fund-desc-info2 {
            display: flex;
            margin-top: 22px;
        }
        .fund-desc-btns {
            display: flex;
            margin-top: 20px;
            .fund-desc-btn {
                cursor: pointer;
                width: 106px;
                text-align: center;
                height: 32px;
                line-height: 32px;
                border-radius: 2px;
                color: var(--color-primary);
                background: #ffffff;
                box-sizing: border-box;
                border: 1px solid var(--color-border-base);
            }
            .fund-desc-btn:hover {
                color: #ffffff;
                background: var(--color-primary);
                box-sizing: border-box;
                border: 1px solid var(--color-primary);
            }
        }
    }
    .magin-left {
        margin-left: 10px;
    }
    .color-fd6112-bold {
        font-weight: bold;
        font-size: 20px;
        color: var(--color-primary);
    }
    .color-f79472 {
        font-size: 16px;
        color: var(--color-primary);
    }
    .width-146 {
        width: 146px;
    }
    .width-156 {
        width: 156px;
    }
    .width-180 {
        width: 180px;
    }
    .color-666 {
        color: var(--color-text-regular);
    }
    .color-333 {
        color: var(--color-text-primary);
    }
    .font-14 {
        font-size: 14px;
    }
}
</style>
